import * as c from 'common/c'
import type { TenantUser } from 'state/account'

export const tenantUsersFetched = (data: TenantUser[]) => {
  return {
    type: c.TENANT_USERS_FETCHED,
    payload: data,
  }
}

export const tenantUserCreated = (data: TenantUser) => {
  return {
    type: c.CREATE_TENANT_USER,
    payload: data,
  }
}

export const tenantUserEdited = (data: TenantUser) => {
  return {
    type: c.UPDATE_TENANT_USER,
    payload: data,
  }
}

export const tenantUserDeleted = (id: string) => {
  return {
    type: c.DELETE_TENANT_USER,
    payload: id,
  }
}
